// extracted by mini-css-extract-plugin
module.exports = {"search-expansion-prompt":"NationwideSearchExpander_search-expansion-prompt__DzKdg","bubble":"NationwideSearchExpander_bubble__JL0Gm"};